import React, { Component } from "react";
import AppModalBs from "../../partials/AppModalBs";
import AppInput from "../../partials/AppInput";

export class ConfigureAssessmentParameterModal extends Component {
  constructor(props) {
    super(props);
    this.state = {
      school_name: [],
      academic_year: "",
      parameters: [{ name: "", max_marks: "", category_id: "" }],
    };
  }

  componentDidMount() {
    window.ConfigureAssessmentParameterModal = this;
  }

  componentDidUpdate(prevProps) {
    if (this.props.editdata !== prevProps.editdata) {
      if (this.props.editdata && Object.keys(this.props.editdata).length > 0) {
        let schoolVal = this.props.editdata.school_name || [];
        if (!Array.isArray(schoolVal) && schoolVal) {
          schoolVal = [schoolVal];
        }
        // Setup initial data
        this.setState({
          school_name: schoolVal,
          academic_year: this.props.editdata.academic_year || "",
          parameters: this.props.editdata.parameters || [{ name: "", max_marks: "", category_id: "" }],
        });
      } else {
        // Reset form when modal opens in Add mode or closes
        this.setState({
          school_name: [],
          academic_year: "",
          parameters: [{ name: "", max_marks: "", category_id: "" }],
        });
      }
    }
  }

  handleAddMore = () => {
    this.setState({
      parameters: [...this.state.parameters, { name: "", max_marks: "", category_id: "" }],
    });
  };

  handleRemoveParameter = (index) => {
    const newParameters = [...this.state.parameters];
    newParameters.splice(index, 1);
    this.setState({ parameters: newParameters });
  };

  handleParameterChange = (index, field, value) => {
    const newParameters = [...this.state.parameters];
    newParameters[index][field] = value;
    this.setState({ parameters: newParameters });
  };

  handleSubmit = (e) => {
    e.preventDefault();
    if (this.props.onSubmit) {
      this.props.onSubmit(e, this.state);
    }
  };

  render() {
    let { id, title, onClose, submitButton, closeButton, viewMode, editMode, submitText = "Save" } = this.props;
    const { parameters, school_name, academic_year } = this.state;

    return (
      <AppModalBs id={id} title={title} onClose={onClose}>
        <form onSubmit={this.handleSubmit} key={this.props.editdata ? (this.props.editdata._id || 'loaded') : 'empty'}>
          <div className="p-3">
            <div className="row mb-3">
              <div className="col-md-6">
                <AppInput
                  type="select"
                  name="school_name"
                  label="School Name"
                  placeholder="Select school name"
                  options={this.props.schoolOptions || []}
                  defaultValue={school_name}
                  onChange={(val) => {
                    let keys = [];
                    if (Array.isArray(val)) {
                      keys = val.map((v) => v.key || v);
                    } else if (val && val.key) {
                      keys = [val.key];
                    }
                    this.setState({ school_name: keys });
                  }}
                  multi={true}
                  required={true}
                  disabled={viewMode || editMode}
                />
              </div>
              <div className="col-md-6">
                <AppInput
                  type="select"
                  name="academic_year"
                  label="Academic Year"
                  placeholder="Select year"
                  options={this.props.academicYearOptions || []}
                  defaultValue={academic_year}
                  onChange={(val) => this.setState({ academic_year: val?.[0]?.key || "" })}
                  required={true}
                  disabled={viewMode}
                />
              </div>
            </div>
          </div>

          <div className="p-3" style={{ backgroundColor: "#fdf8ef" }}>
            {parameters.map((param, index) => (
              <div className="row align-items-end mb-3" key={index}>
                <div className="col-md-4">
                  <AppInput
                    type="text"
                    name={`param_name_${index}`}
                    label="Parameter Name"
                    placeholder="Enter name"
                    defaultValue={param.name}
                    onChange={(e) => this.handleParameterChange(index, "name", e.target.value)}
                    required={true}
                    disabled={viewMode}
                  />
                </div>
                <div className="col-md-4">
                  <AppInput
                    type="select"
                    name={`param_category_${index}`}
                    label="Assessment Category"
                    placeholder="Select category"
                    options={this.props.categoryOptions || []}
                    defaultValue={param.category_id}
                    onChange={(val) => this.handleParameterChange(index, "category_id", val?.[0]?.key || "")}
                    required={true}
                    disabled={viewMode}
                  />
                </div>
                <div className="col-md-3">
                  <AppInput
                    type="text"
                    name={`param_max_marks_${index}`}
                    label="Maximum Marks"
                    placeholder="Enter max marks"
                    defaultValue={param.max_marks}
                    onChange={(e) => this.handleParameterChange(index, "max_marks", e.target.value)}
                    required={true}
                    disabled={viewMode}
                  />
                </div>
                {!viewMode && (
                  <div className="col-md-1 pb-2 d-flex align-items-center gap-2">
                    {parameters.length > 1 && (
                      <span
                        className="font-weight-bold p-0 d-flex align-items-center"
                        style={{ color: "#e74c3c", cursor: "pointer", background: "transparent" }}
                        onClick={() => this.handleRemoveParameter(index)}
                        title="Remove"
                      >
                        <i className="fa fa-trash" style={{ fontSize: "14px" }}></i>
                      </span>
                    )}
                    {index === parameters.length - 1 && (
                      <span
                        className="font-weight-bold p-0 d-flex align-items-center"
                        style={{ color: "#ff9b00", cursor: "pointer", background: "transparent" }}
                        onClick={this.handleAddMore}
                        title="Add More"
                      >
                        <i className="fa fa-plus" style={{ fontSize: "14px" }}></i>
                      </span>
                    )}
                  </div>
                )}
              </div>
            ))}
          </div>

          <div className="p-3 d-flex justify-content-end mt-3">
            {closeButton && (
              <button type="button" className="btn btn-light me-2 px-4" data-bs-dismiss="modal" onClick={onClose} style={{ backgroundColor: "#f2f2f2" }}>
                Cancel
              </button>
            )}
            {submitButton && (
              <button type="submit" className="btn btn-primary px-4" style={{ backgroundColor: "#ff9b00", borderColor: "#ff9b00" }}>
                {submitText}
              </button>
            )}
          </div>
        </form>
      </AppModalBs>
    );
  }
}

export default ConfigureAssessmentParameterModal;
